import axios from 'axios';

const axiosInstance = axios.create();

// Request interceptor — tokeni avtomatik əlavə et
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('teacher_authToken');
  if (token) {
    config.headers.Authorization = `Basic ${token}`;
  }
  return config;
});

// Response interceptor — xətaları idarə et
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error);

    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem('teacher_authToken');
      window.location.hash = '/';
      return Promise.reject(error);
    }

    const data = error.response?.data;

    if (data instanceof Blob) {
      data.text().then(text => {
        let msg = 'Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.';
        try { const json = JSON.parse(text); msg = json.message ?? json.error ?? json.errorMessage ?? msg; } catch (_) {}
        window.dispatchEvent(new CustomEvent('api-error', { detail: { message: msg } }));
      }).catch(() => {
        window.dispatchEvent(new CustomEvent('api-error', { detail: { message: 'Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.' } }));
      });
      return Promise.reject(error);
    }

    const msg = data?.message ?? data?.error ?? data?.errorMessage ?? null;
    window.dispatchEvent(new CustomEvent('api-error', { detail: { message: msg || 'Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.' } }));

    return Promise.reject(error);
  }
);

export default axiosInstance;
